import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import OperationalAction from 'components/Operational/operationalAction';
import { patrolPageActions, patrolTaskSelectors } from '..';
import { PATROL_STATUS } from 'utils/constants/patrol';
import { getUserInfo } from 'reducers/users';
import PopUp from 'components/Operational/PopUp/PopUp';
import { popupText } from 'utils/constants/popupText';

const PatrolOperational = () => {
  //-------hooks----------------------------------------

  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);
  //------------Selectors-------------------------------
  const patrolStatus = useSelector(state =>
    patrolTaskSelectors.getPatrolTaskStatus(state),
  );

  const patrollerId = useSelector(state =>
    patrolTaskSelectors.getPatrollerId(state),
  );
  const isPatrollerGuardOrResponder = useSelector(state =>
    patrolTaskSelectors.getIsPatrollerGuardOrResponder(state),
  );
  const patrolId = useSelector(state => patrolTaskSelectors.getPatrolId(state));
  const currentUser = useSelector(state => getUserInfo(state));
  //-------------------------------------------
  //------------Actions-------------------------------
  const dispatchAbortPatrol = useCallback(() => {
    dispatch(patrolPageActions.abortPatrolTask({ id: patrolId }));
    setOpenDialog(prev => !prev);
  }, [dispatch, patrolId]);

  //-------------------------------------------
  const getActionItem = type => {
    switch (type) {
      case 'abortPatrol':
        return {
          btnText: 'patroldialog_abort_title',
          btnSize: 'xl',
          btnColor: 'primary',
          btnClickHandler: () => setOpenDialog(prev => !prev),
          alignment: 'left',
        };
      default:
        return null;
    }
  };
  const enableAbortButton = useCallback(() => {
    return (
      patrolStatus === PATROL_STATUS.IN_PROGRESS.id &&
      (currentUser.general.id === patrollerId || isPatrollerGuardOrResponder)
    );
  }, [patrolStatus]);

  return (
    <>
      {enableAbortButton() && (
        <OperationalAction
          type={'button'}
          item={getActionItem('abortPatrol')}
        />
      )}
      {openDialog && (
        <PopUp
          title={popupText.abort.popupTitle}
          statusMessage={popupText.abort.popupStatusMessage}
          submit={dispatchAbortPatrol}
          submitBtnText={popupText.abort.submitBtnText}
          cancel={() => setOpenDialog(prev => !prev)}
          cancelBtnText={popupText.abort.cancelBtnText}
          close={() => setOpenDialog(prev => !prev)}
        />
      )}
    </>
  );
};

export default PatrolOperational;
